import { render, staticRenderFns } from "./TierRowForStudent.vue?vue&type=template&id=2e255ee6&"
import script from "./TierRowForStudent.vue?vue&type=script&lang=js&"
export * from "./TierRowForStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports